import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export class VueModalComponent<T> extends Vue {
  @Prop() public modalData!: Record<string, any>;
  @Prop({default: true,}) public showDialog!: boolean;

  public closeModal(data?: T): void { }
}
